import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import * as menuData from '../../config/menu.json';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  public navItens = menuData.nav_itens;
  public username: string;
  public isAdmin: boolean;

  constructor(
    private auth: AuthenticationService,
    public router: Router,
    @Inject(LOCALE_ID) readonly locale: string
  ) { }

  ngOnInit() {
    const email = this.auth.getEmail() || 'john.smith@gmail.com';

    this.username = this.auth.getName();
    this.isAdmin = this.auth.isAdmin();
  }

  shouldShowNavItem(menuItem: any) {
    if (!menuItem.admin) {
      return true;
    }
    if (this.isAdmin) {
      return true;
    }
    return false;
  }

  showSub(menuItem) {
    menuItem.hide_children = (menuItem.hide_children) ? false : true;
  }

  isChildrenActive(item) {
    if (item.children) {
      const childActive = item.children.some(i => i.page === this.router.url.trim().substr(1));
      return !childActive;
    }
    return true;
  }

  logoutClick() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  interpretName(name) {
    if (typeof name === "string") {
      return name;
    }
    if (typeof name !== "object") {
      return "[Not object]";
    }

    if (this.locale.toLowerCase() == "pt" || this.locale.toLowerCase() == "pt-br") {
      if (name["pt-br"]) {
        return name["pt-br"];
      } else if (name["pt-BR"]) {
        return name["pt-BR"];
      } else if (name["pt"]) {
        return name["pt"];
      }
    }

    if (typeof name["en-us"] === "string") {
      return name["en-us"];
    } else if (typeof name["en-US"] === "string") {
      return name["en-US"];
    }
    return name["en"]
  }
}
